import type { ServiceDetail } from "@/types/detail";
import { servicesA } from "@/data/serviceDetails.a";
import { servicesB } from "@/data/serviceDetails.b";

/** All dedicated service pages, in display order. */
export const serviceDetails: ServiceDetail[] = [...servicesA, ...servicesB];

const bySlug = new Map(serviceDetails.map((s) => [s.slug, s]));

export function getServiceDetail(slug?: string): ServiceDetail | undefined {
  return slug ? bySlug.get(slug) : undefined;
}
